type TabBarIconProps = {
  color: string;
  className: string;
};
export const TabBarIcon = ({ color, className }: TabBarIconProps) => {
  return (
    <svg
      className={className}
      width="288"
      height="82"
      viewBox="0 0 288 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="55.5039" width="288" height="26.112" fill="white" />
      <rect
        x="92.928"
        y="72.3999"
        width="102.144"
        height="3.072"
        rx="1.536"
        fill="#1C1C1C"
      />
      <g filter="url(#filter0_d_5641_6624)">
        <rect
          width="288"
          height="43.008"
          transform="translate(0 12.4961)"
          fill="white"
        />
        <g clipPath="url(#clip0_5641_6624)">
          <path
            opacity="0.2"
            d="M53.4719 28.7404H49.4399C49.4399 28.7404 50.3039 20.6764 53.4719 19.5244"
            fill={color}
          />
          <path
            d="M44.832 19.5244V22.4044"
            stroke={color}
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.832 25.5723V33.3483"
            stroke={color}
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.848 19.5244L47.424 22.9804C47.424 23.6679 47.1509 24.3271 46.6648 24.8132C46.1787 25.2993 45.5194 25.5724 44.832 25.5724C44.1445 25.5724 43.4853 25.2993 42.9992 24.8132C42.5131 24.3271 42.24 23.6679 42.24 22.9804L42.816 19.5244"
            stroke={color}
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M53.4719 28.7404H49.4399C49.4399 28.7404 50.3039 20.6764 53.4719 19.5244V33.3484"
            stroke={color}
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M37.4114 48.5098C36.7591 48.5098 36.1601 48.3567 35.6143 48.0506C35.0685 47.7444 34.6359 47.3217 34.3164 46.7826C33.9969 46.2368 33.8371 45.6211 33.8371 44.9356C33.8371 44.2566 33.9969 43.6476 34.3164 43.1085C34.6359 42.5627 35.0685 42.1367 35.6143 41.8305C36.1601 41.5244 36.7591 41.3713 37.4114 41.3713C38.0704 41.3713 38.6694 41.5244 39.2085 41.8305C39.7543 42.1367 40.1836 42.5627 40.4965 43.1085C40.816 43.6476 40.9757 44.2566 40.9757 44.9356C40.9757 45.6211 40.816 46.2368 40.4965 46.7826C40.1836 47.3217 39.7543 47.7444 39.2085 48.0506C38.6627 48.3567 38.0637 48.5098 37.4114 48.5098ZM37.4114 47.2618C37.8307 47.2618 38.2002 47.1686 38.5196 46.9823C38.8391 46.7893 39.0887 46.5164 39.2684 46.1636C39.4482 45.8108 39.538 45.4015 39.538 44.9356C39.538 44.4696 39.4482 44.0636 39.2684 43.7175C39.0887 43.3647 38.8391 43.0952 38.5196 42.9088C38.2002 42.7224 37.8307 42.6293 37.4114 42.6293C36.9921 42.6293 36.6194 42.7224 36.2932 42.9088C35.9737 43.0952 35.7241 43.3647 35.5444 43.7175C35.3647 44.0636 35.2748 44.4696 35.2748 44.9356C35.2748 45.4015 35.3647 45.8108 35.5444 46.1636C35.7241 46.5164 35.9737 46.7893 36.2932 46.9823C36.6194 47.1686 36.9921 47.2618 37.4114 47.2618ZM43.4134 43.7674C43.5931 43.4746 43.826 43.2449 44.1122 43.0785C44.4051 42.9121 44.7379 42.8289 45.1106 42.8289V44.2966H44.7412C44.3019 44.2966 43.9691 44.3997 43.7428 44.6061C43.5232 44.8124 43.4134 45.1718 43.4134 45.6844V48.4399H42.0156V42.9088H43.4134V43.7674ZM45.6927 45.6544C45.6927 45.0953 45.8025 44.5994 46.0222 44.1668C46.2485 43.7341 46.5546 43.4013 46.9407 43.1684C47.3267 42.9354 47.756 42.8189 48.2286 42.8189C48.588 42.8189 48.9308 42.8988 49.257 43.0586C49.5831 43.2117 49.8427 43.418 50.0357 43.6776V41.0518H51.4534V48.4399H50.0357V47.6213C49.8627 47.8941 49.6197 48.1138 49.3069 48.2802C48.9941 48.4466 48.6313 48.5298 48.2186 48.5298C47.7527 48.5298 47.3267 48.41 46.9407 48.1704C46.5546 47.9308 46.2485 47.5946 46.0222 47.162C45.8025 46.7227 45.6927 46.2202 45.6927 45.6544ZM50.0457 45.6744C50.0457 45.3349 49.9791 45.0454 49.846 44.8058C49.7129 44.5595 49.5332 44.3731 49.3069 44.2467C49.0806 44.1135 48.8376 44.047 48.5781 44.047C48.3185 44.047 48.0789 44.1102 47.8592 44.2367C47.6396 44.3631 47.4598 44.5495 47.3201 44.7958C47.187 45.0354 47.1204 45.3216 47.1204 45.6544C47.1204 45.9872 47.187 46.2801 47.3201 46.533C47.4598 46.7793 47.6396 46.969 47.8592 47.1021C48.0855 47.2352 48.3251 47.3018 48.5781 47.3018C48.8376 47.3018 49.0806 47.2385 49.3069 47.1121C49.5332 46.9789 49.7129 46.7926 49.846 46.553C49.9791 46.3067 50.0457 46.0138 50.0457 45.6744ZM57.9604 45.5546C57.9604 45.7542 57.9471 45.934 57.9204 46.0937H53.8769C53.9102 46.4931 54.05 46.8059 54.2962 47.0322C54.5425 47.2585 54.8454 47.3717 55.2048 47.3717C55.7239 47.3717 56.0934 47.1487 56.313 46.7027H57.8206C57.6608 47.2352 57.3547 47.6745 56.9021 48.0206C56.4495 48.3601 55.8937 48.5298 55.2347 48.5298C54.7023 48.5298 54.223 48.4133 53.797 48.1804C53.3777 47.9407 53.0482 47.6046 52.8086 47.172C52.5757 46.7393 52.4592 46.2401 52.4592 45.6744C52.4592 45.102 52.5757 44.5994 52.8086 44.1668C53.0416 43.7341 53.3677 43.4013 53.7871 43.1684C54.2064 42.9354 54.6889 42.8189 55.2347 42.8189C55.7606 42.8189 56.2298 42.9321 56.6425 43.1584C57.0618 43.3847 57.3846 43.7075 57.6109 44.1269C57.8439 44.5395 57.9604 45.0154 57.9604 45.5546ZM56.5127 45.1552C56.506 44.7958 56.3762 44.5096 56.1233 44.2966C55.8704 44.0769 55.5609 43.9671 55.1948 43.9671C54.8487 43.9671 54.5558 44.0736 54.3162 44.2866C54.0832 44.4929 53.9401 44.7825 53.8869 45.1552H56.5127ZM60.3784 43.7674C60.5581 43.4746 60.791 43.2449 61.0772 43.0785C61.3701 42.9121 61.7029 42.8289 62.0756 42.8289V44.2966H61.7062C61.2669 44.2966 60.9341 44.3997 60.7078 44.6061C60.4882 44.8124 60.3784 45.1718 60.3784 45.6844V48.4399H58.9806V42.9088H60.3784V43.7674Z"
          fill={color}
        />
        <g clipPath="url(#clip1_5641_6624)">
          <path
            d="M150.144 26.3203V34.0003H137.856V26.3203"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M151.68 22.48H136.32V26.32H151.68V22.48Z"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144 34V22.48"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144 22.4801H140.544C140.035 22.4801 139.546 22.2779 139.186 21.9178C138.826 21.5577 138.624 21.0694 138.624 20.5601C138.624 20.0509 138.826 19.5626 139.186 19.2025C139.546 18.8424 140.035 18.6401 140.544 18.6401C143.232 18.6401 144 22.4801 144 22.4801Z"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144 22.4801H147.456C147.965 22.4801 148.454 22.2779 148.814 21.9178C149.174 21.5577 149.376 21.0694 149.376 20.5601C149.376 20.0509 149.174 19.5626 148.814 19.2025C148.454 18.8424 147.965 18.6401 147.456 18.6401C144.768 18.6401 144 22.4801 144 22.4801Z"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M132.377 41.531V48.4399H131.468V43.2882L129.172 48.4399H128.533L126.227 43.2782V48.4399H125.318V41.531H126.296L128.852 47.2419L131.408 41.531H132.377ZM138.63 42.9687L135.335 51.0158H134.397L135.475 48.38L133.269 42.9687H134.277L135.994 47.4016L137.691 42.9687H138.63ZM147.477 43.4979C147.284 43.0918 147.004 42.779 146.638 42.5594C146.272 42.3331 145.846 42.2199 145.36 42.2199C144.874 42.2199 144.435 42.3331 144.042 42.5594C143.656 42.779 143.35 43.0985 143.124 43.5178C142.904 43.9305 142.794 44.4097 142.794 44.9555C142.794 45.5013 142.904 45.9805 143.124 46.3932C143.35 46.8059 143.656 47.1254 144.042 47.3517C144.435 47.5713 144.874 47.6812 145.36 47.6812C146.039 47.6812 146.598 47.4781 147.037 47.0721C147.477 46.6661 147.733 46.117 147.806 45.4248H145.031V44.686H148.775V45.3848C148.721 45.9573 148.542 46.4831 148.235 46.9623C147.929 47.4349 147.527 47.8109 147.027 48.0905C146.528 48.3634 145.972 48.4998 145.36 48.4998C144.714 48.4998 144.125 48.3501 143.593 48.0506C143.06 47.7444 142.638 47.3217 142.325 46.7826C142.019 46.2435 141.866 45.6344 141.866 44.9555C141.866 44.2766 142.019 43.6676 142.325 43.1285C142.638 42.5827 143.06 42.16 143.593 41.8605C144.125 41.5543 144.714 41.4012 145.36 41.4012C146.099 41.4012 146.751 41.5843 147.317 41.9503C147.889 42.3164 148.305 42.8323 148.565 43.4979H147.477ZM150.445 42.0801C150.272 42.0801 150.126 42.0202 150.006 41.9004C149.886 41.7806 149.826 41.6342 149.826 41.4611C149.826 41.2881 149.886 41.1416 150.006 41.0218C150.126 40.902 150.272 40.8421 150.445 40.8421C150.611 40.8421 150.751 40.902 150.864 41.0218C150.984 41.1416 151.044 41.2881 151.044 41.4611C151.044 41.6342 150.984 41.7806 150.864 41.9004C150.751 42.0202 150.611 42.0801 150.445 42.0801ZM150.884 42.9687V48.4399H149.976V42.9687H150.884ZM154.659 43.7175H153.511V48.4399H152.603V43.7175H151.894V42.9687H152.603V42.5793C152.603 41.967 152.759 41.521 153.072 41.2415C153.391 40.9553 153.9 40.8122 154.599 40.8122V41.5709C154.2 41.5709 153.917 41.6508 153.751 41.8106C153.591 41.9637 153.511 42.2199 153.511 42.5793V42.9687H154.659V43.7175ZM156.827 43.7175V46.9423C156.827 47.2086 156.883 47.3983 156.996 47.5114C157.11 47.6179 157.306 47.6712 157.586 47.6712H158.254V48.4399H157.436C156.93 48.4399 156.551 48.3235 156.298 48.0905C156.045 47.8575 155.918 47.4748 155.918 46.9423V43.7175H155.209V42.9687H155.918V41.5909H156.827V42.9687H158.254V43.7175H156.827ZM161.292 48.5298C160.873 48.5298 160.497 48.4599 160.164 48.3201C159.831 48.1737 159.568 47.974 159.375 47.7211C159.182 47.4615 159.076 47.1653 159.056 46.8325H159.994C160.021 47.1054 160.147 47.3284 160.374 47.5014C160.607 47.6745 160.909 47.761 161.282 47.761C161.628 47.761 161.901 47.6845 162.101 47.5314C162.301 47.3783 162.4 47.1853 162.4 46.9523C162.4 46.7127 162.294 46.5363 162.081 46.4232C161.868 46.3034 161.538 46.1869 161.093 46.0737C160.686 45.9672 160.354 45.8607 160.094 45.7542C159.841 45.6411 159.622 45.478 159.435 45.265C159.255 45.0454 159.166 44.7592 159.166 44.4064C159.166 44.1269 159.249 43.8706 159.415 43.6376C159.582 43.4047 159.818 43.2216 160.124 43.0885C160.43 42.9487 160.78 42.8789 161.172 42.8789C161.778 42.8789 162.267 43.0319 162.64 43.3381C163.013 43.6443 163.212 44.0636 163.239 44.5961H162.331C162.311 44.3099 162.194 44.0803 161.981 43.9072C161.775 43.7341 161.495 43.6476 161.142 43.6476C160.816 43.6476 160.557 43.7175 160.364 43.8573C160.171 43.9971 160.074 44.1801 160.074 44.4064C160.074 44.5861 160.131 44.7359 160.244 44.8557C160.364 44.9688 160.51 45.062 160.683 45.1352C160.863 45.2018 161.109 45.2783 161.422 45.3649C161.815 45.4714 162.134 45.5779 162.38 45.6844C162.627 45.7842 162.836 45.9373 163.009 46.1436C163.189 46.35 163.282 46.6195 163.289 46.9523C163.289 47.2518 163.206 47.5214 163.039 47.761C162.873 48.0006 162.637 48.1903 162.331 48.3301C162.031 48.4632 161.685 48.5298 161.292 48.5298Z"
          fill="#8E8E93"
        />
        <g clipPath="url(#clip2_5641_6624)">
          <path
            d="M233.664 26.3203H246.336"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M233.664 21.7119H246.336"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M233.664 30.9282H246.336"
            stroke="#8E8E93"
            strokeWidth="1.536"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M236.053 41.531V48.4399H235.144V43.2882L232.848 48.4399H232.209L229.903 43.2782V48.4399H228.994V41.531H229.972L232.528 47.2419L235.084 41.531H236.053ZM239.98 48.5298C239.467 48.5298 239.001 48.4133 238.582 48.1804C238.169 47.9474 237.843 47.6179 237.604 47.1919C237.371 46.7593 237.254 46.2601 237.254 45.6943C237.254 45.1352 237.374 44.6427 237.614 44.2167C237.86 43.7841 238.193 43.4546 238.612 43.2283C239.031 42.9953 239.5 42.8789 240.02 42.8789C240.539 42.8789 241.008 42.9953 241.427 43.2283C241.847 43.4546 242.176 43.7807 242.416 44.2067C242.662 44.6327 242.785 45.1286 242.785 45.6943C242.785 46.2601 242.659 46.7593 242.406 47.1919C242.16 47.6179 241.823 47.9474 241.397 48.1804C240.971 48.4133 240.499 48.5298 239.98 48.5298ZM239.98 47.7311C240.306 47.7311 240.612 47.6545 240.898 47.5014C241.184 47.3484 241.414 47.1187 241.587 46.8125C241.767 46.5064 241.857 46.1336 241.857 45.6943C241.857 45.255 241.77 44.8823 241.597 44.5761C241.424 44.27 241.198 44.0437 240.918 43.8972C240.639 43.7441 240.336 43.6676 240.01 43.6676C239.677 43.6676 239.371 43.7441 239.091 43.8972C238.818 44.0437 238.599 44.27 238.432 44.5761C238.266 44.8823 238.183 45.255 238.183 45.6943C238.183 46.1403 238.262 46.5164 238.422 46.8225C238.589 47.1287 238.808 47.3583 239.081 47.5114C239.354 47.6579 239.654 47.7311 239.98 47.7311ZM244.888 43.8573C245.048 43.5445 245.274 43.3015 245.567 43.1285C245.867 42.9554 246.23 42.8689 246.656 42.8689V43.8074H246.416C245.398 43.8074 244.888 44.3598 244.888 45.4647V48.4399H243.98V42.9687H244.888V43.8573ZM252.696 45.4947C252.696 45.6677 252.686 45.8508 252.666 46.0438H248.293C248.327 46.5829 248.51 47.0056 248.842 47.3117C249.182 47.6113 249.591 47.761 250.071 47.761C250.463 47.761 250.789 47.6712 251.049 47.4915C251.315 47.3051 251.502 47.0588 251.608 46.7526H252.586C252.44 47.2785 252.147 47.7078 251.708 48.0406C251.269 48.3667 250.723 48.5298 250.071 48.5298C249.551 48.5298 249.085 48.4133 248.673 48.1804C248.267 47.9474 247.947 47.6179 247.714 47.1919C247.481 46.7593 247.365 46.2601 247.365 45.6943C247.365 45.1286 247.478 44.6327 247.704 44.2067C247.931 43.7807 248.247 43.4546 248.653 43.2283C249.065 42.9953 249.538 42.8789 250.071 42.8789C250.59 42.8789 251.049 42.992 251.448 43.2183C251.848 43.4446 252.154 43.7574 252.367 44.1568C252.586 44.5495 252.696 44.9955 252.696 45.4947ZM251.758 45.305C251.758 44.9589 251.681 44.6627 251.528 44.4164C251.375 44.1635 251.165 43.9738 250.899 43.8473C250.64 43.7142 250.35 43.6476 250.031 43.6476C249.571 43.6476 249.179 43.7941 248.852 44.0869C248.533 44.3798 248.35 44.7858 248.303 45.305H251.758Z"
          fill="#8E8E93"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5641_6624"
          x="-9.216"
          y="0.208094"
          width="306.432"
          height="61.4398"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3.072" />
          <feGaussianBlur stdDeviation="4.608" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0 0.117647 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5641_6624"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5641_6624"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_5641_6624">
          <rect
            width="18.432"
            height="18.432"
            fill="white"
            transform="translate(38.7839 17.104)"
          />
        </clipPath>
        <clipPath id="clip1_5641_6624">
          <rect
            width="18.432"
            height="18.432"
            fill="white"
            transform="translate(134.784 17.104)"
          />
        </clipPath>
        <clipPath id="clip2_5641_6624">
          <rect
            width="18.432"
            height="18.432"
            fill="white"
            transform="translate(230.784 17.104)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TabBarIcon;
